module.exports = __webpack_public_path__ + "static/img/rongyu3.ad7386c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rongyu3.jpg
// module id = IER9
// module chunks = 1